/* Cart stock status: keeps the "In stock / Only X left / Out of stock" lines
   in sync with Shopify and re-checks them before the customer goes to checkout.

   The numbers always come from the server-rendered cart (the snippet
   lushe-cart-stock.liquid). This script never decides stock itself: it only
   re-fetches that server-rendered cart and shows what it says. */
(function () {
  var REFRESH_SECTIONS = ['cart-drawer', 'main-cart-items'];
  var bypassCheckoutCheck = false;

  function fetchFreshStock() {
    // Re-render the cart's sections on the server (always current inventory)
    var url = '/?sections=' + REFRESH_SECTIONS.join(',');
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('bad response');
        return r.json();
      })
      .then(function (sections) {
        var doc = document.implementation.createHTMLDocument('');
        var html = REFRESH_SECTIONS.map(function (id) { return sections[id] || ''; }).join('');
        doc.body.innerHTML = html;
        return doc;
      });
  }

  function setChecking(on) {
    document.querySelectorAll('[data-lushe-stock]').forEach(function (el) {
      el.classList.toggle('lushe-stock--checking', on);
      var text = el.querySelector('.lushe-stock__text');
      if (!text) return;
      if (on) {
        if (!el.hasAttribute('data-lushe-prev-text')) el.setAttribute('data-lushe-prev-text', text.textContent);
        text.textContent = 'Checking availability';
      } else if (el.hasAttribute('data-lushe-prev-text')) {
        text.textContent = el.getAttribute('data-lushe-prev-text');
        el.removeAttribute('data-lushe-prev-text');
      }
    });
  }

  function markUnavailable() {
    document.querySelectorAll('[data-lushe-stock]').forEach(function (el) {
      el.classList.remove('lushe-stock--checking');
      el.removeAttribute('data-lushe-prev-text');
      var text = el.querySelector('.lushe-stock__text');
      if (text) text.textContent = 'Availability temporarily unavailable';
      el.classList.add('lushe-stock--unknown');
    });
  }

  // Replace each stock block (and its quantity limit) with the fresh server copy
  function applyFresh(doc) {
    var fresh = {};
    doc.querySelectorAll('[data-lushe-stock][data-lushe-line-key]').forEach(function (el) {
      fresh[el.getAttribute('data-lushe-line-key')] = el;
    });
    document.querySelectorAll('[data-lushe-stock][data-lushe-line-key]').forEach(function (el) {
      var next = fresh[el.getAttribute('data-lushe-line-key')];
      if (!next) return;
      el.replaceWith(next.cloneNode(true));
    });
    // Keep the quantity boxes' maximum in step with the fresh stock
    document.querySelectorAll('.quantity__input[data-quantity-line-key]').forEach(function (input) {
      var key = input.getAttribute('data-quantity-line-key');
      var block = fresh[key];
      if (!block) return;
      var limit = block.getAttribute('data-lushe-available');
      if (limit !== '' && limit !== null) input.max = limit;
    });
  }

  function refresh(silent) {
    if (!silent) setChecking(true);
    return fetchFreshStock()
      .then(function (doc) {
        if (!silent) setChecking(false);
        applyFresh(doc);
        return doc;
      })
      .catch(function () {
        markUnavailable();
        return null;
      });
  }

  function hasIssue(root) {
    return !!root.querySelector('[data-lushe-stock-issue]');
  }

  // "Change to N" and "Remove" buttons inside a warning
  document.addEventListener('click', function (event) {
    var setBtn = event.target.closest('[data-lushe-set-qty]');
    var removeBtn = event.target.closest('[data-lushe-remove]');
    if (!setBtn && !removeBtn) return;

    var row = (setBtn || removeBtn).closest('.cart-item');
    if (!row) return;
    event.preventDefault();

    if (setBtn) {
      var input = row.querySelector('.quantity__input');
      if (!input) return;
      input.value = setBtn.getAttribute('data-lushe-set-qty');
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      var link = row.querySelector('cart-remove-button a, cart-remove-button button');
      if (link) link.click();
    }
  });

  // After any cart change (quantity, remove, add) show fresh stock everywhere
  var cartChangeTimer;
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      clearTimeout(cartChangeTimer);
      cartChangeTimer = setTimeout(function () {
        if (document.querySelector('[data-lushe-stock]')) refresh(true);
      }, 600);
    });
  }

  // Re-check when the drawer opens and when the tab becomes visible again
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.lusheStockWatched) return;
    drawer.dataset.lusheStockWatched = '1';
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) refresh();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  document.addEventListener('DOMContentLoaded', watchDrawer);
  watchDrawer();

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && document.querySelector('[data-lushe-stock]')) refresh();
  });

  // Fresh check right before checkout. Shopify's checkout validates stock too;
  // this just stops the customer a step earlier with a clear message.
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('button[name="checkout"], input[name="checkout"]');
      if (!btn || bypassCheckoutCheck) return;
      if (!document.querySelector('[data-lushe-stock]')) return;

      event.preventDefault();
      event.stopPropagation();
      var form = btn.form || btn.closest('form');
      btn.setAttribute('aria-busy', 'true');

      refresh().then(function (doc) {
        btn.removeAttribute('aria-busy');
        if (doc && hasIssue(document)) {
          var first = document.querySelector('[data-lushe-stock-issue]');
          if (first && first.scrollIntoView) first.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        // Nothing wrong (or the check could not run): go on, Shopify validates at checkout
        bypassCheckoutCheck = true;
        if (form && form.requestSubmit) {
          form.requestSubmit(btn);
        } else if (form) {
          form.submit();
        }
        setTimeout(function () { bypassCheckoutCheck = false; }, 1500);
      });
    },
    true
  );
})();
